import { isPlatformServer } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

import { Booth, Hall } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {
  @Input() prefix?: string;
  @Input() exhibition_halls?: Hall[] = [];
  @Input() fair_id?: string;
  @Input() inverted = false;
  @Input() inline = false;
  @Input() hasIcon = true;
  @Input() locationClickable = true;

  localized_prefix?: string;
  isSSR = false;

  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.isSSR = isPlatformServer(platformId);
  }

  ngOnInit() {
    this.localized_prefix = $localize`${this.prefix}`;
  }

  identifyHall(_index: number, hall: Hall): string {
    return `${hall.fair_id}/${hall.id}`;
  }

  identifyBooth(_index: number, booth: Booth): string {
    return booth.name;
  }
}
